angular.module('bribac.services.updateRuleSetReadFormat', [])

  .factory('updateRuleSetReadFormat', function() {
    return function updateRuleSetReadFormat(ruleSetInEditFormat) {
      var updated = angular.copy(ruleSetInEditFormat)
      // TODO: Update all unit types. Implement some converter.
      updated.bacLimit[ruleSetInEditFormat.bacLimit.unit] = ruleSetInEditFormat.bacLimit.value
      return updated
    }
  })
